import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="pt-16 min-h-screen flex items-center relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/8c83f15951dad0d1ece22ab65c8444ac.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              {t('hero.title')}
            </h1>
            <p className="text-xl mb-8 leading-relaxed text-gray-100">
              {t('hero.subtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToContact}
                className="bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer"
              >
                {t('hero.startJourney')}
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById('services');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-gray-900 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer"
              >
                {t('hero.learnMore')}
              </button>
            </div>
          </div>
          <div className="relative">
            <div className="bg-white/90 backdrop-blur-sm p-8 rounded-2xl shadow-2xl">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Today's Featured Meal</h3>
                <p className="text-gray-600">Grilled Salmon with Quinoa & Vegetables</p>
              </div>
              <img
                src="https://readdy.ai/api/search-image?query=Grilled%20salmon%20fillet%20with%20quinoa%20and%20roasted%20vegetables%20in%20a%20meal%20prep%20container%2C%20professional%20food%20photography%2C%20appetizing%20presentation%2C%20macro-balanced%20meal%2C%20high%20quality%20realistic&width=400&height=300&seq=featured-meal&orientation=landscape"
                alt="Featured MacroFit Meal"
                className="rounded-xl w-full h-48 object-cover mb-4"
              />
              <div className="grid grid-cols-3 gap-4 text-center">
                <div className="bg-teal-50 p-3 rounded-lg">
                  <p className="text-2xl font-bold text-teal-600">35g</p>
                  <p className="text-sm text-gray-600">Protein</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg">
                  <p className="text-2xl font-bold text-blue-600">45g</p>
                  <p className="text-sm text-gray-600">Carbs</p>
                </div>
                <div className="bg-orange-50 p-3 rounded-lg">
                  <p className="text-2xl font-bold text-orange-600">18g</p>
                  <p className="text-sm text-gray-600">Fat</p>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center space-x-4">
                <div className="bg-teal-100 p-3 rounded-full">
                  <i className="ri-truck-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">{t('hero.statsTitle')}</p>
                  <p className="text-sm text-gray-600">{t('hero.statsSubtitle')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}